<template>
  <div class="toast">
    {{ toastTitle }}
  </div>
</template>

<script>
import { mapState } from 'vuex';
import * as toastTypes from '@/store/modules/toast/mutation-types/';

export default {
  name: 'Toast',
  computed: {
    ...mapState('toast', ['toastTitle', 'toastMessage', 'toastType']),
  },
  methods: {
    fireNotification() {
      this.$notify({
        title: this.toastTitle,
        message: this.toastMessage,
        type: this.toastType,
      });
      this.$store.commit(`toast/${toastTypes.RESET_TOAST}`);
    },
  },
  beforeUpdate() {
    if (this.toastMessage && this.toastTitle && this.toastType) {
      this.fireNotification();
    }
  },
};
</script>



// WEBPACK FOOTER //
// Toast.vue?9ab0d8c4